<div class="min-h-screen bg-white text-gray-800">

  <!-- Main Container -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">

    <!-- Breadcrumb -->
    <!-- <div class="flex items-center gap-2 text-xs text-gray-400 mb-3">
      <span class="text-purple-600 font-medium">Home</span>
      <span>›</span>
      <span>FAQ</span>
    </div> -->

    <!-- Header -->
    <div class="mb-5">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-900">
        Frequently Asked Questions
      </h1>

      <p class="text-xs sm:text-sm text-gray-500 mt-1">
        Find answers to your questions about shopping, orders, payments,
        delivery and more.
      </p>
    </div>


    <!-- Search -->
    <div class="relative mb-4">
      <input
        type="text"
        placeholder="Search your question..."
        class="w-full h-10 sm:h-11 pl-10 pr-4 border border-gray-200
               rounded-md text-xs sm:text-sm outline-none
               focus:ring-2 focus:ring-purple-200 focus:border-purple-400"
      />

      <svg
        class="absolute left-3 top-1/2 -translate-y-1/2
               w-4 h-4 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m21 21-4.35-4.35m2.35-5.65a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
        />
      </svg>
    </div>


    <!-- Category Buttons -->
    <div
      class="flex gap-2 overflow-x-auto pb-2 mb-5
             scrollbar-hide"
    >

      <button
        *ngFor="let category of categories"
        (click)="selectCategory(category)"
        class="flex items-center gap-2 px-3 sm:px-4 py-2
               border rounded-md whitespace-nowrap text-xs
               sm:text-sm transition"
        [ngClass]="
          selectedCategory === category
            ? 'bg-purple-600 text-white border-purple-600'
            : 'bg-white text-gray-600 border-gray-200 hover:border-purple-300'
        "
      >
        {{ category }}
      </button>

    </div>


    <!-- Main Content -->
    <div
      class="grid grid-cols-1 lg:grid-cols-[1fr_270px]
             gap-5 lg:gap-6"
    >

      <!-- LEFT -->
      <div>

        <h2 class="text-sm sm:text-base font-bold text-gray-900 mb-2">
          Popular Questions
        </h2>

        <!-- FAQ List -->
        <div class="space-y-1.5">

          <div
            *ngFor="let faq of faqs; let i = index"
            class="border border-gray-200 rounded-md overflow-hidden"
          >

            <!-- Question -->
            <button
              type="button"
              (click)="toggleFaq(i)"
              class="w-full flex items-center justify-between
                     gap-3 px-3 sm:px-4 py-3 text-left
                     hover:bg-gray-50 transition"
            >

              <span
                class="text-xs sm:text-sm font-medium"
                [ngClass]="
                  openedFaq === i
                    ? 'text-purple-600'
                    : 'text-gray-800'
                "
              >
                {{ faq.question }}
              </span>

              <span
                class="flex-shrink-0 text-gray-500 text-base"
              >
                {{ openedFaq === i ? '−' : '+' }}
              </span>

            </button>


            <!-- Answer -->
            <div
              *ngIf="openedFaq === i"
              class="px-3 sm:px-4 pb-3 text-xs
                     sm:text-sm leading-5 text-gray-500"
            >
              {{ faq.answer }}
            </div>

          </div>

        </div>

      </div>


      <!-- RIGHT SIDEBAR -->
      <div class="space-y-4">

        <!-- Need Help -->
        <div
          class="border border-purple-100 bg-purple-50/30
                 rounded-lg p-5 text-center"
        >

          <div
            class="w-10 h-10 mx-auto mb-2 rounded-full
                   flex items-center justify-center
                   bg-purple-100 text-purple-600"
          >
            🎧
          </div>

          <h3 class="font-semibold text-sm text-gray-900">
            Still need help?
          </h3>

          <p class="text-xs text-gray-500 mt-1 mb-3">
            Our support team is here to help you.
          </p>

          <button
            class="bg-purple-600 hover:bg-purple-700
                   text-white text-xs font-medium
                   px-6 py-2 rounded-md transition"
          >
            Contact Us
          </button>

        </div>


        <!-- More Help -->
        <div class="border border-gray-200 rounded-lg p-3">

          <h3 class="text-sm font-bold text-gray-900 mb-2">
            More Help
          </h3>

          <div class="divide-y divide-gray-100">

            <a
              *ngFor="let item of helpLinks"
              href="javascript:void(0)"
              class="flex items-center justify-between
                     py-2.5 text-xs text-gray-600
                     hover:text-purple-600"
            >
              <span class="flex items-center gap-2">
                <span class="text-purple-500">
                  {{ item.icon }}
                </span>

                {{ item.title }}
              </span>

              <span>›</span>
            </a>

          </div>

        </div>

      </div>

    </div>


    <!-- Bottom Features -->
    <div
      class="mt-6 border border-gray-200 rounded-lg
             grid grid-cols-2 md:grid-cols-4"
    >

      <div
        class="flex items-center gap-3 px-4 py-4
               border-b md:border-b-0 md:border-r
               border-gray-200"
      >
        <span class="text-xl">🚚</span>

        <div>
          <p class="text-xs font-semibold text-purple-600">
            Free Delivery
          </p>
          <p class="text-[10px] text-gray-500">
            On all orders above ₹499
          </p>
        </div>
      </div>


      <div
        class="flex items-center gap-3 px-4 py-4
               border-b md:border-b-0 md:border-r
               border-gray-200"
      >
        <span class="text-xl">↩️</span>

        <div>
          <p class="text-xs font-semibold text-purple-600">
            Easy Returns
          </p>
          <p class="text-[10px] text-gray-500">
            14 days return policy
          </p>
        </div>
      </div>


      <div
        class="flex items-center gap-3 px-4 py-4
               border-r border-gray-200"
      >
        <span class="text-xl">🛡️</span>

        <div>
          <p class="text-xs font-semibold text-purple-600">
            Secure Payments
          </p>
          <p class="text-[10px] text-gray-500">
            100% secure payments
          </p>
        </div>
      </div>


      <div
        class="flex items-center gap-3 px-4 py-4"
      >
        <span class="text-xl">🎧</span>

        <div>
          <p class="text-xs font-semibold text-purple-600">
            24/7 Support
          </p>
          <p class="text-[10px] text-gray-500">
            We're here to help
          </p>
        </div>
      </div>

    </div>

  </div>

</div>